<template>
  <div class="login">
    <div class="container">
      <br class="d-none d-md-block"><br class="d-none d-md-block">
      <div class="text-center" v-if="isLoading">
        <b-spinner variant="primary" label="Loading..."></b-spinner>
      </div>
      <div v-else>
        <div class="row mt-5">
          <div class="col-lg-7 text-white">
            <intro-text></intro-text>
          </div>
          <div class="col-lg-5">
            <div class="card shadow-xs no-border radius10">
              <div class="card-body">
                <h1 class="h3 text-center mt-3 mb-4">Регистрация</h1>

                <validation-observer ref="observer" v-slot="{ handleSubmit }">
                  <b-form @submit.stop.prevent="handleSubmit(register)" class="primary px-md-5">
                    <validation-provider
                      name="First name"
                      :rules="{ required: true, min: 2, alpha: true }"
                      v-slot="validationContext"
                    >
                      <b-form-group>
                        <b-form-input id="firstName"
                          type="text"
                          size="lg"
                          v-model="form.firstName"
                          placeholder="Имя"
                          :state="getValidationState(validationContext)">
                        </b-form-input>
                        <b-form-invalid-feedback id="input-1-live-feedback">{{ validationContext.errors[0] }}</b-form-invalid-feedback>
                      </b-form-group>
                    </validation-provider>

                    <validation-provider
                      name="Фамилия"
                      :rules="{ required: true, min: 2, alpha: true }"
                      v-slot="validationContext"
                    >
                      <b-form-group>
                        <b-form-input id="lastName"
                          type="text"
                          size="lg"
                          v-model="form.lastName"
                          placeholder="Фамилия"
                          :state="getValidationState(validationContext)">
                        </b-form-input>
                        <b-form-invalid-feedback id="input-1-live-feedback">{{ validationContext.errors[0] }}</b-form-invalid-feedback>
                      </b-form-group>
                    </validation-provider>

                    <validation-provider
                      name="E-mail"
                      :rules="{ email: true, required: true }"
                      v-slot="validationContext"
                    >
                      <b-form-group>
                        <b-form-input id="email"
                          type="email"
                          size="lg"
                          v-model="form.email"
                          placeholder="E-mail"
                          :state="getValidationState(validationContext)">
                        </b-form-input>
                        <b-form-invalid-feedback id="input-1-live-feedback">{{ validationContext.errors[0] }}</b-form-invalid-feedback>
                      </b-form-group>
                    </validation-provider>

                    <validation-provider
                      name="Пароль"
                      :rules="{required: true, min: 6 }"
                      v-slot="validationContext"
                    >
                      <b-form-group>
                        <b-form-input id="password"
                          type="password"
                          size="lg"
                          v-model="form.password"
                          placeholder="Пароль"
                          :state="getValidationState(validationContext)">
                        </b-form-input>
                        <b-form-invalid-feedback id="input-1-live-feedback">{{ validationContext.errors[0] }}</b-form-invalid-feedback>
                      </b-form-group>
                    </validation-provider>
                    
                    <b-button type="submit" variant="success" size="lg" block :disabled="isFormLoading">
                      Присоединиться →
                    </b-button>
                    <br>
                    <p class="small">Регистриуясь, вы соглашаетесь с <router-link :to="{ name: 'terms' }">правилами и условиями</router-link> сайта.</p>
                    
                    <div class="text-center">
                      <button class="btn btn-light btn-block" @click="googleSignIn">
                        <img src="/static/images/icons/google.png" width="20"> Войти через Google
                      </button>
                    </div>
                  </b-form>
                </validation-observer>
                <br>
                
              </div>
              <div class="card-footer">
                <p class="text-center mb-0">Уже есть аккаунт? <router-link :to="{ name: 'login' }" class="semibold">Войти</router-link></p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import IntroText from './IntroText'
import { mapState } from 'vuex'
export default {
  name: 'register',
  components: {
    IntroText
  },
  data () {
    return {
      isLoading: null,
      hasError: false,
      errorsInfo: {
        firstName: null,
        lastName: '',
        email: null,
        password: null
      },
      form: {
        firstName: null,
        lastName: null,
        email: null,
        password: null,
        onboardingComplete: false
      },
      bodyClass: Math.random() > 0.5 ? 'bg-renat' : 'bg-ruslan'
    }
  },
  computed: {
    ...mapState({
      isFormLoading: state => state.auth.loading
    })
  },
  beforeCreate () {
    if (this.$store.state.isLoggedIn) {
      this.$router.push({ name: 'hikes' }).catch(() => {})
    }
  },
  methods: {
    googleSignIn () {
      this.$store.dispatch('GOOGLE_SIGN_IN').then((response) => {
        this.$router.push({ name: 'hikes' }).catch(() => {})
      }, error => {
        this.errorsInfo = error.response.data
        this.hasError = true
      })
    },
    getValidationState ({ dirty, validated, valid = null }) {
      return dirty || validated ? valid : null
    },
    register () {
      const { form } = this
      this.hasError = false
      this.$store.dispatch('REGISTER', form).then((response) => {
        this.$router.push({ name: 'hikes' }).catch(() => {})
      }, error => {
        this.errorsInfo = error.response.data
        this.hasError = true
      })
    }
  },
  mounted () {
    this.isLoading = true
    this.$store.dispatch('SET_LOADING', true)
    setTimeout(() => {
      this.isLoading = false
      this.$store.dispatch('SET_LOADING', false)
    }, 300)
    let el = document.body
    el.classList.add(this.bodyClass)
  },
  destroyed () {
    let el = document.body
    el.classList.remove(this.bodyClass)
  }
}
</script>
